<template>
    <div :class="inputClass">
        <div v-for="(option, index) in options" :key="index" class="form-input-toggle__option">
            <input
                :id="optionId(option)"
                :checked="isOptionChecked(option)"
                :data-checked="isOptionChecked(option)"
                :name="uid"
                :value="option.value"
                :autofocus="hasAutofocus"
                :required="isRequired"
                type="radio"
                :disabled="isDisabled"
                @click="change(option.value)"
            />

            <label :for="optionId(option)">
                <common-icon :name="radioIcon(option)" size="medium"></common-icon>

                <span>{{ option.label }}</span>
            </label>

            <div class="form-input-toggle__end">
                <slot :name="optionSlotName(option)"></slot>
            </div>
            <span v-if="showInfoTip">
                <common-info-tip>
                    <span>{{ infoTipMessage }}</span>
                </common-info-tip>
            </span>
        </div>

        <span v-if="errorMessage" class="form-input-text--error">{{ errorMessage }}</span>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'
    import { v4 as uuidv4 } from 'uuid'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: [String, Number, Boolean, Object], default: undefined },
            options: { type: Array, required: true },
            direction: { type: String, default: null },
            color: { type: String, default: 'primary' },
            showInfoTip: { type: Boolean, default: false },
            infoTipMessage: { type: String, default: '' },
        },

        data: () => ({
            uid: uuidv4(),
        }),

        computed: {
            inputClass() {
                return {
                    'form-input-toggle': true,
                    [`form-input-toggle--direction-${this.direction || 'row'}`]: true,
                    'form-input-toggle--is-disabled': this.isDisabled,
                    [`form-input-toggle__option--${this.color}`]: true,
                }
            },
        },

        methods: {
            isOptionChecked({ value }) {
                if ([null, undefined].includes(this.value)) {
                    return false
                }
                return JSON.stringify(this.value) === JSON.stringify(value)
            },

            radioIcon(option) {
                return this.isOptionChecked(option) ? 'radio-on' : 'radio-off'
            },

            optionId(option) {
                return [this.uid, JSON.stringify(option.value)].join('-')
            },

            optionSlotName({ value }) {
                return `option-${value}`
            },
        },
    }
</script>
